import { styled } from '@compiled/react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const UserListContainer = styled.ul({
	listStyleType: 'none',
	listStylePosition: 'inside',
	display: 'flex',
	flexDirection: 'column',
	margin: '0px',
	padding: '0px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const UserListRow = styled.li({
	margin: '0px',
	padding: '0px',
});
